import React, { useState } from "react";
import Modal from "react-modal";
import CameraView from "./CameraView";
import Resizer from "react-image-file-resizer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faArrowLeft,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import * as faceapi from "face-api.js";
import Swal from "sweetalert2";

const AddPhoto = ({ setToggleCapture, index }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isCameraNeeded, setIsCameraNeeded] = useState(false);
  function openModal() {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
    setIsCameraNeeded(false);
  }

  const handleCameraClick = () => {
    setIsCameraNeeded(true);
  };

  const handleFileUploadClick = () => {
    setIsCameraNeeded(false);
    document.getElementById("file-input").click();
  };

  const getFile = (e) => {
    var file = e.target.files[0];
    if (!file.type.match("image.*") || file.type === "image/svg+xml") {
      Swal.fire({
        icon: "error",
        title: "Ungültiges Dateiformat",
        text: "Bitte laden Sie nur Bilder hoch (SVGs sind nicht erlaubt).",
        allowOutsideClick: false,
      });
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      Swal.fire({
        title: "Bild wird verarbeitet...",
        html: "Bitte warten",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      //const uri = reader.result;
      Resizer.imageFileResizer(
        file,
        1000,
        1000,
        "JPEG",
        70,
        0,
        async (resizedUri) => {
          const image = new Image();
          var existingFiles =
            JSON.parse(localStorage.getItem("photos" + index)) || [];

          const fileName = file.name;
          const fileSize = file.size;

          const isDuplicate = existingFiles.some(
            (existingFile) =>
              existingFile.name === fileName && existingFile.size === fileSize
          );
          if (isDuplicate) {
            Swal.fire({
              icon: "error",
              title: "Duplikat erkannt",
              text: "Dieses Bild ist bereits hochgeladen.",
              allowOutsideClick: false,
            });
            return;
          }
          image.onload = async () => {
            const blurredImageUri = await detectAndBlurFaces(image);

            storeImage({
              name: file.name,
              size: file.size,
              decoded_image: blurredImageUri,
            });
            Swal.close();
          };
          image.src = resizedUri;
        },
        "base64"
      );
    };

    reader.readAsDataURL(file);
  };

  const detectAndBlurFaces = async (image) => {
    await Promise.all([
      faceapi.nets.ssdMobilenetv1.loadFromUri("/models"),
      faceapi.nets.faceLandmark68Net.loadFromUri("/models"),
      faceapi.nets.faceRecognitionNet.loadFromUri("/models"),
    ]);

    const detections = await faceapi
      .detectAllFaces(image, new faceapi.SsdMobilenetv1Options())
      .withFaceLandmarks();

    const canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext("2d");

    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    detections.forEach((face) => {
      const { x, y, width, height } = face.detection.box;

      const centerX = x + width / 2;
      const centerY = y + height / 2;
      const radiusX = width / 2;
      const radiusY = height / 2;
      const rotation = 0;
      const startAngle = 0;
      const endAngle = 2 * Math.PI;

      context.filter = "blur(10px)";
      context.beginPath();
      context.ellipse(
        centerX,
        centerY,
        radiusX,
        radiusY,
        rotation,
        startAngle,
        endAngle
      );
      context.closePath();
      context.fill();

      context.fillStyle = "rgba(0, 0, 0, 1)";
      context.beginPath();
      context.ellipse(
        centerX,
        centerY,
        radiusX,
        radiusY,
        rotation,
        startAngle,
        endAngle
      );
      context.fill();
    });

    context.filter = "none";

    const blurredImage = new Image();
    blurredImage.src = canvas.toDataURL("image/jpeg");

    return blurredImage.src;
  };

  const storeImage = async (result) => {
    var photos = JSON.parse(localStorage.getItem("photos" + index)) || [];
    const photoObject = {
      name: result.name,
      size: result.size,
      description: "",
      decoded_image: result.decoded_image,
    };
    photos.push(photoObject);
    localStorage.setItem("photos" + index, JSON.stringify(photos));
    closeModal();
    setToggleCapture(true);
  };

  return (
    <>
      <label
        className="col-3"
        style={{
          border: "2px dotted black",
          marginTop: 5,
          height: 216,
          width: 216,
        }}
      >
        <div
          className="d-flex justify-content-center"
          style={{
            alignItems: "center",
            alignContent: "center",
            height: "100%",
          }}
        >
          <button
            onClick={openModal}
            style={{ cursor: "pointer", border: "none", background: "none" }}
          >
            <FontAwesomeIcon icon={faCamera} size="1x" />
          </button>
        </div>
      </label>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Photo Options"
      >
        <div className="d-flex flex-column align-items-center">
          <button
            style={{ padding: 10, width: 170, marginBottom: 10 }}
            className="btn btn-primary"
            onClick={handleCameraClick}
          >
            <FontAwesomeIcon icon={faCamera} size="1x" /> Foto aufnehmen
          </button>
          <button
            style={{ padding: 10, width: 170, marginBottom: 10 }}
            className="btn btn-secondary"
            onClick={handleFileUploadClick}
          >
            <FontAwesomeIcon icon={faUpload} /> Foto hochladen
          </button>
          <div className="d-flex justify-content-center">
            <button
              style={{ padding: 10, width: 170 }}
              className="btn btn-secondary"
              onClick={closeModal}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Zurück
            </button>
          </div>
          <input
            id="file-input"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={getFile}
          />
          {isCameraNeeded === true && (
            <CameraView
              closeModal={closeModal}
              setToggleCapture={setToggleCapture}
              index={index}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
  },
};

export default AddPhoto;
